import { useState } from 'react';
import { useRedeemCoupon } from '@/react-query/podcast-queries';
import toast from 'react-hot-toast';
import { Tag } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

const RedeemCouponWidget = () => {
    const [code, setCode] = useState('');
    const { mutate: redeem, isPending, error } = useRedeemCoupon();
    const [successMessage, setSuccessMessage] = useState<string | null>(null);

    const handleRedeem = () => {
        if (!code.trim()) {
            toast.error("Please enter a coupon code");
            return;
        }

        setSuccessMessage(null);
        
        redeem(code, {
            onSuccess: () => {
                setSuccessMessage("Coupon redeemed successfully! Credits added.");
                setCode('');
                toast.success("Coupon redeemed!");
            },
            onError: () => {
                 // handled by query mostly, but just in case
            }
        });
    };

    return (
        <div className="bg-white rounded-xl border border-border shadow-sm overflow-hidden">
             <div className="p-4 border-b bg-slate-50 flex items-center gap-2">
                <Tag className="h-5 w-5 text-primary" />
                <h3 className="font-semibold text-gray-900">Redeem Coupon</h3>
             </div>
             
             <div className="p-6 space-y-4">
                 <div className="flex gap-2">
                    <Input 
                        placeholder="ENTER CODE" 
                        value={code} 
                        onChange={(e) => setCode(e.target.value.toUpperCase())}
                        className="flex-1 uppercase"
                    />
                    <Button onClick={handleRedeem} disabled={isPending}>
                        {isPending ? 'Redeeming...' : 'Apply'}
                    </Button>
                 </div>

                 {successMessage && (
                     <div className="p-3 bg-green-50 text-green-700 text-sm rounded-lg border border-green-100">
                         {successMessage}
                     </div>
                 )}
                 {error && (
                     <div className="p-3 bg-red-50 text-red-700 text-sm rounded-lg border border-red-100">
                         {(error as any)?.response?.data?.message || 'Failed to redeem coupon'}
                     </div>
                 )}
             </div>
        </div>
    );
};

export default RedeemCouponWidget;
